<template>
	<div class="login-container">
		<!-- 顶部图标和标题 -->
		<div class="header">
			<div class="icon-wrapper">
				<img class="login-icon" :src="selectedStore.storeImg?selectedStore.storeImg:defaultlogo" mode="aspectFit"/>
			</div>
			<div class="welcome-text">欢迎登录</div>
		</div>
		<!-- 交互卡片 -->
		<div class="form-card">
			<!-- 门店选择 -->
			<div class="form-item" @click="selectStore">
				<div class="item-content">
					<div class="label">门店</div>
					<div class="placeholder">{{ selectedStore.Name || '请选择门店' }}</div>
				</div>
				<img class="arrow-icon" src="@/assets/images/report/arrow-right.png" mode="aspectFit"/>
			</div>

			<!-- 账号输入 -->
			<div class="form-item">
				<div class="item-content">
					<div class="label">账号</div>
					<input class="input-field" type="text" placeholder="请输入账号" placeholder-class="placeholder"
						v-model="username" />
				</div>
			</div>

			<!-- 密码输入 -->
			<div class="form-item">
				<div class="item-content">
					<div class="label">密码</div>
					<input class="input-field" type="password" placeholder="请输入密码" placeholder-class="placeholder"
						v-model="password" />
				</div>
			</div>
		</div>

		<!-- 登录按钮 -->
		<div class="login-section">
			<button class="login-btn" @click="handleLogin">登录</button>
		</div>

		<!-- 门店选择弹窗 -->
		<div class="picker-modal" v-if="showStorePicker">
			<div class="picker-mask" @click="closePicker"></div>
			<div class="picker-content">
				<div class="picker-header">
					<div class="picker-title">选择门店</div>
					<div class="picker-close" @click="closePicker">关闭</div>
				</div>
				<div class="picker-list">
					<div class="picker-item" v-for="(store, index) in storeList" :key="index"
						@click="confirmStore(store)">
						<div class="picker-item-view">
							<img class="picker-item-image" :src="store.storeImg?store.storeImg:defaultlogo" mode="aspectFit" />
							<div class="picker-item-text">{{ store.Name }}</div>
							<img class="picker-item-choose"
								:src="selectedStore.Name==store.Name?radioactive:radiounactive" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	
	import { employeeSearch, getdashboardSetting, login, sysparaSearch } from '@/api/login';

	import {
		ALL_VPN_LIST,
		CURRENT_VPN,
		DEPT_NAME,
		FUNCTION_STRING,
		OPERATOR_ID,
		OPERATOR_NAME,
		OPERATOR_PWD,
		OPERATOR_PositionName,
		OPERATOR_SEX,
		TxtPadPosSwitchParlorcode,
		VPN_ID,
	} from '@/api/login';
	
import { handleLocalStorage, handleSessionStorage } from '@/utils';
import { isNullOrEmpt } from '@/utils/ToastUtils';
	export default {
			name: 'ReportLogin',
		data() {
			return {
				defaultlogo:require("@/assets/images/report/bottomLogoJg.png") ,
				radioactive:require("@/assets/images/report/radioactive.png") ,
				radiounactive:require("@/assets/images/report/radiounactive.png") ,
				username: '',
				password: '',
				selectedStore: {},
				showStorePicker: false,
				storeList: []
			}
		},
		
		created() {
		    this.queryvpnInfo()
			getdashboardSetting()
			this.updateUsernameAndPwd()
		},
		methods: {
			updateUsernameAndPwd(){
			 	const useId = handleLocalStorage.get(OPERATOR_ID)
				const pwd = handleLocalStorage.get(OPERATOR_PWD)
				if(useId==undefined||useId==null){
					this.username = ""
				}else{
					this.username = useId
				}
				if(pwd==undefined||pwd==null){
					this.password = ""
				}else{
					this.password = pwd
				}
			},
			queryvpnInfo() {
				this.selectedStore = handleSessionStorage.get("vpnInfo");
				const lastStores = localStorage.getItem("allStoreList");
		        const vpnList = JSON.parse(lastStores)||[];
				this.storeList = []
				vpnList.forEach(vItem => {
					const findImg = vItem.Claims.find((element) => element.TypeId === 1);
					console.log(findImg);
					if (findImg) {
						vItem.storeImg = `${findImg.CdnUrl}/${findImg.Value}`;
					}
					this.storeList.push(vItem)
				})
				if (!this.selectedStore || (!this.selectedStore.Name)) {
					if (this.storeList.length > 0) {
						this.selectedStore = this.storeList[0]
						this.confirmStore(this.selectedStore)
					}
				}else{
					this.confirmStore(this.selectedStore)
				}
			},
			// 选择门店
			selectStore() {
				this.showStorePicker = true;
			},
			// 关闭选择器
			closePicker() {
				this.showStorePicker = false;
			},
			// 确认选择门店
			confirmStore(store) {
				const vpnInfo = {
					...store,
					id: store.Id,
					code: store.SaaSCode,
					...store.SaasVpnSetting
				}
				handleLocalStorage.set(VPN_ID, store.Id+'')
				handleLocalStorage.set(CURRENT_VPN, vpnInfo)
				this.selectedStore = store;
				this.showStorePicker = false;
			},

			// 登录处理
			handleLogin() {
				// 表单验证
				if (!this.selectedStore) {
					this.$toast("请选择门店");
					return;
				}

				if (!this.username) {
					this.$toast("请输入账号");	
					return;
				}
				if (!this.password) {
					this.$toast("请输入密码");
					return;
				}

				this.$toast("加载中,请稍后……");
				login({
					VpnId: this.selectedStore.Id,
					OperatorId: this.username,
					MachineId: 'weixin',
					PassWord: this.password,
					IsSkipVerifyPwd: false
				}).then(resp => {
					const result = JSON.parse(resp)
					const mErrorMsg = result.Result.ErrorMsg
					console.log('mErrorMsgmErrorMsg === ' + mErrorMsg)
					if (isNullOrEmpt(mErrorMsg)) {
						const mEmployState = result.Result.EmployeeInfo.EmployState + ''
						if (mEmployState == "在职") {
							const sex = result.Result.EmployeeInfo.Sex == null ? "男" : result.Result.EmployeeInfo
								.Sex
							if (sex == "女") {
								handleLocalStorage.set(OPERATOR_SEX, "女")
							} else {
								handleLocalStorage.set(OPERATOR_SEX, "男")
							}
							var type = result.Result.RightType
							handleLocalStorage.set(OPERATOR_ID, result.Result.EmployeeInfo.EmployID)
							handleLocalStorage.set(OPERATOR_PWD, this.password)
							handleLocalStorage.set(OPERATOR_NAME, result.Result.EmployeeInfo.EmployName)
							if (type === undefined || type === null || type == '') {
								type = result.Result.EmployeeInfo.PositionName
							}
							handleLocalStorage.set(OPERATOR_PositionName, type)
							this.queryDeprt()
						} else {
							this.$toast("已经不在职，不可登录操作");
						}
					} else {
						this.$toast(mErrorMsg);
					}
				})
			},
			/*查询部门*/
			queryDeprt() {
				const mParam = {
					paraname: TxtPadPosSwitchParlorcode,
					VpnId: this.selectedStore.Id
				}
				sysparaSearch(mParam).then(resp => {
					const result = JSON.parse(resp)
					const mErrorMsg = result.Result.ErrorMsg
					if (isNullOrEmpt(mErrorMsg)) {
						const mParaValue = result.Result.ParaValue + ''
						const list =[]
						if (isNullOrEmpt(mParaValue)) {
							handleLocalStorage.set(TxtPadPosSwitchParlorcode, list)
						} else {
							const temp = mParaValue.split(",").filter(mode => mode.length > 1)
							if (temp.length > 0) {
								handleLocalStorage.set(DEPT_NAME, temp[0])
							}
							list.push(...temp)
							handleLocalStorage.set(TxtPadPosSwitchParlorcode, list)
						}
						this.queryEmployeeSearch()
					} else {
						this.$toast(mErrorMsg);
					}
				})
			},

			/**查询权限*/
			queryEmployeeSearch() {
				const mParam = {
					OperatorId: handleLocalStorage.get(OPERATOR_ID),
					OperatorName: handleLocalStorage.get(OPERATOR_NAME),
					MachineId: 'weixin',
					DepartmentName: handleLocalStorage.get(DEPT_NAME),
					Parlorcode: handleLocalStorage.get(DEPT_NAME),
					VpnId: this.selectedStore.Id
				}
				employeeSearch(mParam).then(resp => {
					const result = JSON.parse(resp)
					const mErrorMsg = result.Result.ErrorMsg
					if (isNullOrEmpt(mErrorMsg)) {
						const lstFunctionId = result.Result.lstFunctionId || []
						handleLocalStorage.set(FUNCTION_STRING, lstFunctionId)
						this.$router.push('/dashboard')
					}else{
						this.$toast(mErrorMsg);
					}
				})
			},
		}
	}
</script>

<style scoped>
	.login-container {
		min-height: 100vh;
		background-color: #f5f5f5;
		padding: 80px 48px 48px;
		display: flex;
		flex-direction: column;
	}

	/* 头部区域 */
	.header {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-bottom: 80px;
	}

	.icon-wrapper {
		width: 140px;
		height: 140px;
		border-radius: 70px;
		background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 32px;
		box-shadow: 0 8px 24px rgba(102, 126, 234, 0.3);
	}

	.login-icon {
		width: 80px;
		height: 80px;
	}

	.welcome-text {
		font-size: 48px;
		font-weight: 500;
		color: #333333;
	}

	/* 表单卡片 */
	.form-card {
		background-color: #ffffff;
		border-radius: 24px;
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
		overflow: hidden;
	}

	.form-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 40px 32px;
		border-bottom: 1px solid #e8e8e8;
		min-height: 120px;
	}

	.form-item:last-child {
		border-bottom: none;
	}

	.item-content {
		display: flex;
		flex-direction: column;
		flex: 1;
	}

	.label {
		font-size: 28px;
		color: #333333;
		margin-bottom: 12px;
		font-weight: 500;
	}

	.placeholder {
		font-size: 28px;
		color: #999999;
	}

	.input-field {
		font-size: 28px;
		color: #333333;
		padding: 0;
		margin: 0;
		height: 40px;
		background-color: transparent;
		border-color: transparent;
		border-width: 0px;
		line-height: 40px;
	}

	.arrow-icon {
		width: 32px;
		height: 32px;
		margin-left: 16px;
	}

	/* 登录区域 */
	.login-section {
		margin-top: 48px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.login-btn {
		width: 100%;
		height: 96px;
		background: #595AEC;
		border-radius: 48px;
		border: none;
		color: #ffffff;
		font-size: 32px;
		font-weight: 500;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: 0 8px 24px rgba(102, 126, 234, 0.4);
		margin-bottom: 24px;
	}

	.login-btn::after {
		border: none;
	}

	.forgot-password {
		font-size: 24px;
		color: #667eea;
		align-self: flex-end;
		margin-top: 8px;
	}

	/* 选择器弹窗 */
	.picker-modal {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 999;
	}

	.picker-mask {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.5);
	}

	.picker-content {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		background-color: #ffffff;
		border-radius: 32px 32px 0 0;
		max-height: 60vh;
		display: flex;
		flex-direction: column;
	}

	.picker-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 32px;
		border-bottom: 1px solid #e8e8e8;
	}

	.picker-title {
		font-size: 32px;
		font-weight: 500;
		color: #333333;
	}

	.picker-close {
		font-size: 28px;
		color: #667eea;
	}

	.picker-list {
		flex: 1;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;
        overflow-y: auto;
	}

	.picker-item {
		padding: 32px;
		border-bottom: 1px solid #f5f5f5;
	}

	.picker-item-view {
		height: 100px;
		width: 96%;
		align-items: center;
		display: flex;
		margin-left: 2%;
	}

	.picker-item-image {
		height: 100px;
		width: 100px;
	}

	.picker-item-text {
		flex: 1;
		text-align: right;
		height: 100px;
		line-height: 100px;
		font-size: 32px;
		color: #333333;
	}

	.picker-item-choose {
		margin-left: 10px;
		height: 50px;
		width: 50px;
	}
</style>